import { apiClient } from '@app/api';
import { useTimezone } from '@app/core/hooks/useTimezone';
import { Station, toDateTimeStr } from '@mi-front/core';
import moment from 'moment';
import { ReportView } from '../../../../core/reports/components/ReportView';
import { ElasticSearchReport } from '../../types';
import { SearchForm } from './components/form/SearchForm';
import { SearchResult } from './components/result/SearchResult';

interface Props {
  station: Station;
}

export function SearchView(p: Props) {
  const { station } = p;
  const tz = useTimezone();

  return (
    <ReportView<ElasticSearchReport>
      defaultValues={{
        from: toDateTimeStr(moment().tz(tz).startOf('day').toISOString()),
        to: toDateTimeStr(moment().tz(tz).endOf('day').toISOString()),
        input: '',
        pageSize: 50,
        pageIndex: 0,
      }}
      download={false}
      queryParamsTransform={{}}
      reportFn={async (values) => {
        return apiClient.transcriptions.fetchSearch(
          station.slug,
          values.from,
          values.to,
          values.input,
        );
      }}
      Form={SearchForm}
      Result={SearchResult}
    />
  );
}
